import {
	GET_USER_PROFILE,
	SET_LOGIN,
	SET_USER_PROFILE,
	SET_LOADING,
	SET_ROLE, // <-- Add this
  } from "../actions/actionTypes";
  
  const initialState = {
	profileData: {},
	isLoggedIn: false,
	loading: false,
	role: localStorage.getItem("TENANT_ROLE") || null, // <-- Add this
  };
  
  const userReducer = (state = initialState, action) => {
  
	switch (action.type) {
	  case GET_USER_PROFILE: {
		return { ...state.profileData };
	  }
  
	  case SET_USER_PROFILE: {
		return {
		  ...state,
		  profileData: { ...state.profileData, ...action.payload },
		};
	  }
  
	  case SET_LOGIN: {
		state.isLoggedIn = action.payload.login;
		return { ...state };
	  }
  
	  case SET_LOADING: {
		state.loading = action.payload;
		return { ...state };
	  }
	  case SET_ROLE: { // <-- Add this
		return {
		  ...state,
		  role: action.payload,
		};
	  }
  
	  default:
		return state;
	}
  };
  
  export default userReducer;
